import React from 'react';
import { authRoles } from 'app/auth';

// TODO Update path to use ID not name
export const CredentialsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.admin, 
	routes: [
		{
			path: '/credentials',
			component: React.lazy(() => import('./Credentials'))
		}
	]
};
